import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

interface DialogData {
    siteName: string;
    unityCount: number;
    equipmentCount: number;
}

@Component({
    selector: 'app-confirm-delete-site-modal',
    templateUrl: './confirm-delete-site-modal.component.html',
    styleUrls: ['./confirm-delete-site-modal.component.scss']
})
export class ConfirmDeleteSiteModalComponent {
    constructor(
        private dialogRef: MatDialogRef<ConfirmDeleteSiteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
